import { ModalsWrapperContext } from '@kanda-libs/ks-design-library';
import { useCallback, useContext } from 'react';

export interface OptionPopoverMobileHook {
  onClick: () => void;
  onClose: () => void;
}

export default function useOptionPopoverMobile(): OptionPopoverMobileHook {
  const { showModal, hideModal } = useContext(ModalsWrapperContext);

  const onClick = useCallback(
    () => showModal('open-banking-info'),
    [showModal],
  );

  const onClose = useCallback(
    () => hideModal('open-banking-info'),
    [hideModal],
  );

  return {
    onClick,
    onClose,
  };
}
